import dashboard from './modules/dashboard';
import BasicLayout from '@/layouts/basic-layout';

import org from './modules/org';
import bpm from './modules/bpm';
import notice from './modules/notice';
import news from './modules/news';
import website from './modules/website';
import sys from './modules/sys';
import schedule from './modules/schedule';
import ca from './modules/ca';
import pcn from './modules/pcn';
/**
 * 在主框架内显示
 */
const meta = {
    auth: false,
    cache: true
};

const frameIn = [
    {
        path: '/',
        name: 'home',
        redirect: {
            name: 'dashboard'
        },
        component: BasicLayout,
        children: [
            {
                path: 'index',
                name: 'index',
                redirect: {
                    name: 'dashboard'
                }
            },
            {
                path: 'log',
                name: 'log',
                meta: {
                    title: '前端日志',
                    auth: false
                },
                component: () => import('@/pages/system/log')
            },
            // 刷新页面 必须保留
            {
                path: 'refresh',
                name: 'refresh',
                hidden: true,
                component: {
                    beforeRouteEnter (to, from, next) {
                        next(instance => instance.$router.replace(from.fullPath));
                    },
                    render: h => h()
                }
            },
            // 页面重定向 必须保留
            {
                path: 'redirect/:route*',
                name: 'redirect',
                hidden: true,
                component: {
                    beforeRouteEnter (to, from, next) {
                        next(instance => instance.$router.replace(JSON.parse(from.params.route)));
                    },
                    render: h => h()
                }
            }
        ]
    },
    
    dashboard,
    org,
    bpm,
    notice,
    news,
    website,
    sys,
    schedule,
    ca,
    pcn
];

/**
 * 在主框架之外显示
 */

const frameOut = [
    // 登录
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '$t:page.login.title',
            auth:true,
        },
        component: () => import('@/pages/account/login')
    },
    // 供应商登录
    {
      path: '/supplier-login',
      name: 'supplierLogin',
      meta: {
          title: '$t:page.login.title'
      },
      component: () => import('@/pages/account/login/supplier')
    },
    // 注册
    {
        path: '/register',
        name: 'register',
        meta: {
            title: '$t:page.register.title',
            auth:true,
        },
        component: () => import('@/pages/account/register')
    },
    // 注册结果
    {
        path: '/register/result',
        name: 'register-result',
        meta: {
            auth: true,
            title: '注册结果'
        },
        component: () => import('@/pages/account/register/result')
    },
    // 重置密码
    {
        path: '/resetPassword/:account?',
        name: 'resetPassword',
        meta: {
            title: '重置密码',
            auth:true,
        },
        component: () => import('@/pages/account/resetpassword')
    },
    // 测试界面
    {
        path: '/test',
        name: 'test',
        meta: {
            title: '测试界面',
        },
        component: () => import('@/components/ab-cust-dialog/test.vue')
    },
    {
        path: '/borrowError',
        name: 'borrowError',
        meta: {
            title: '浏览器访问提示'
        },
        component: () => import('@/pages/account/error')
    },
    {
        path: '/borrowErrorSupplier',
        name: 'borrowErrorSupplier',
        meta: {
            title: '浏览器访问提示'
        },
        component: () => import('@/pages/account/suppliererror')
    },
    // 忘记密码
    {
        path: '/forgotpwd',
        name: 'forgotpwd',
        meta: {
            title: '$t:page.login.forgot',
            auth:true,
        },
        component: () => import('@/pages/account/forgotpwd')
    },
    // 重置密码
    {
        path: '/pwd/reset',
        name: 'pwd-reset',
        meta: {
            title: '重置密码',
            auth:true,
        },
        component: () => import('@/pages/account/reset')
    },
];

/**
 * 错误页面
 */

const errorPage = [
    {
        path: '/403',
        name: '403',
        meta: {
            title: '403'
        },
        component: () => import('@/pages/system/error/403')
    },
    {
        path: '/500',
        name: '500',
        meta: {
            title: '500'
        },
        component: () => import('@/pages/system/error/500')
    },
    {
        path: '*',
        name: '404',
        meta: {
            title: '404'
        },
        component: () => import('@/pages/system/error/404')
    }
];

// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 重新组织后导出
export default [
    ...frameIn,
    ...frameOut,
    ...errorPage
];
